document.addEventListener('DOMContentLoaded', () => {
  const colorSwatches = document.querySelectorAll('.color-swatch'); // your swatch buttons
  const mediaItems = document.querySelectorAll('.product-media-container[data-color]');

  // Hide all except default on load (optional)
  const defaultColor = colorSwatches[0]?.dataset.color || 'Default';
  mediaItems.forEach(item => {
    item.style.display = (item.dataset.color === defaultColor) ? 'block' : 'none';
  });

  // Swatch click handling
  colorSwatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      const selectedColor = swatch.dataset.color;

      mediaItems.forEach(item => {
        if (item.dataset.color === selectedColor || selectedColor === 'All') {
          item.style.display = 'block';
        } else {
          item.style.display = 'none';
        }
      });

      // Optional: Highlight selected swatch
      colorSwatches.forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');
    });
  });
});